import { render } from "./_boardIdx.vue?vue&type=template&id=49212780"
import script from "./_boardIdx.vue?vue&type=script&lang=js"
export * from "./_boardIdx.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Stage-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__